import { useLocation } from "@opendash/router";

export function useHref() {
  const location = useLocation();

  return window.location.href;
}
